import { useState } from "react";
import ContactModal from "@/components/ContactModal";

const LINKS = ["Instagram", "Contact"];

export default function Footer() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer data-testid="footer" className="bg-black text-paper border-t border-white/10 py-14">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-8">
          <div>
            <p className="font-display text-2xl sm:text-3xl tracking-wide">THE SHUTUP COMPANY</p>
            <p className="font-hindi text-pink text-2xl sm:text-3xl mt-2 -rotate-1 inline-block">
              शटअप &amp; स्पीक वाइल्ड.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-3">
            {LINKS.map((l) => (
              <a
                key={l}
                href={l === "Instagram" ? "https://www.instagram.com/shutupviraj/" : "#top"}
                {...(l === "Instagram" ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                onClick={
                  l === "Contact"
                    ? (e) => {
                        e.preventDefault();
                        setContactOpen(true);
                      }
                    : undefined
                }
                data-testid={`footer-link-${l.toLowerCase()}`}
                className="font-sans text-paper/60 text-xs tracking-[0.25em] hover:text-turq transition-colors inline-block py-3 -my-1"
              >
                {l.toUpperCase()}
              </a>
            ))}
          </nav>
        </div>
        <p className="font-sans text-paper/35 text-[11px] tracking-[0.3em] mt-12">© THE SHUTUP COMPANY</p>
      </div>
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
    </footer>
  );
}
